module.exports = __webpack_public_path__ + "static/media/inicioChatDark.ea57f590.png";